import React from "react";
import { DialogContent } from "@mui/material";

const DSDialogContent = (props: React.ComponentProps<typeof DialogContent>) => {
  return <DialogContent {...props} />;
};

export default DSDialogContent;
